(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');

  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      nav.toggleAttribute('hidden');
      document.body.classList.toggle('menu-open', !expanded);
    });
  }

  document.querySelectorAll('[data-sticky-submit]').forEach(function (button) {
    button.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (!form) return;
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.click();
    });
  });

  var contactSuccess = document.querySelector('[data-contact-success]');
  if (contactSuccess && window.location.search.indexOf('contact_posted=true') !== -1) {
    contactSuccess.hidden = false;
  }
})();
